<input
  type="text"
  nz-input
  [nzSize]="nzSize"
  [maxLength]="maxlength"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [value]="value$ | async"
  data-cy="payment-beneficiary-account-input"
/>
